import { render } from "./SizeTable.vue?vue&type=template&id=25d83110&scoped=true"
import script from "./SizeTable.vue?vue&type=script&lang=js"
export * from "./SizeTable.vue?vue&type=script&lang=js"

import "./SizeTable.vue?vue&type=style&index=0&id=25d83110&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d83110"]])

export default __exports__